import { render } from "./Redeem.vue?vue&type=template&id=2f37aac3"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"

import "./Redeem.vue?vue&type=style&index=0&id=2f37aac3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__